import React from "react";
import Screen from "./Screen";
interface Props {}

export default ({}: Props) => {
  return <Screen />;
};
